import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Navbar from './Navbar'
import { selectUserRole } from '../reducers/userDataReducer'

// Loads the standalone KB chatbot widget (elevatedliving-support-kb/plugin) for building-managing roles.
// One script tag; the widget reads the `token` cookie itself and the service re-checks the role server-side.
const SUPPORT_WIDGET_ROLES = ['PropertyManager', 'Administrator', 'Manager']
const SupportWidget = () => {
  const role = useSelector(selectUserRole)
  useEffect(() => {
    const src = import.meta.env.VITE_SUPPORT_WIDGET_URL
    if (
      !src ||
      !SUPPORT_WIDGET_ROLES.includes(role) ||
      document.getElementById('el-kb-widget-script')
    )
      return
    document.body.appendChild(
      Object.assign(document.createElement('script'), {
        src,
        id: 'el-kb-widget-script',
        async: true,
      }),
    )
  }, [role])
  return null
}

class Dashboard extends React.Component {
  static Container = ({ children, className }) => {
    return <div className={`ctp-dashboard__container ${className || ''}`}>{children}</div>
  }

  render() {
    return (
      <div className="ctp-dashboard">
        <Navbar />
        <Outlet />
        <SupportWidget />
      </div>
    )
  }
}

Dashboard.propTypes = {
  children: PropTypes.element,
}

export default Dashboard
